import React, { useEffect, useState, useMemo, useRef } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import toast from 'react-hot-toast';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Loader from '../../components/loader';
import Button from '../../components/elements/button';
import { URLS } from '../../_config';
import Drawer from '../../components/Drawer';
import { Dropdown, Menu } from '../../components/Dropdown';
import Filters from '../../components/filters';
import { filterConfigType } from '../../_config/types';
import Icon from '../../components/icons';
import { titleCell } from '../../components/elements/function';
import { useDialog } from '../../store/api/hooks/dialogHook';
import { downloadExcel, downloadPDF } from '../../_common/functions';
import { Link } from 'react-router-dom';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';
import CreateUser from './_components/createUser';

ModuleRegistry.registerModules([AllCommunityModule]);

const User: React.FC = () => {
    const userApi = useUserApi();
    const commonApi = useCommonApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setrowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>(null);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('userFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('userFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const filtersRef: any = useRef();
    const createUserRef: any = useRef();
    const { confirm } = useDialog();

    const getUserTypes = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            // When API endpoint is ready, use:
            userApi.getUserTypes(
                payload,
                (resp: any) => {
                    resolve(
                        resp?.userTypeList
                            ? resp.userTypeList.map((ut: any) => {
                                return {
                                    label: ut.name,
                                    value: ut.userTypeID,
                                };
                            })
                            : []
                    );
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    };


    const filterConfig: filterConfigType[] = [
        { name: 'User Type', type: 'dropdown', key: 'userTypeID', async: getUserTypes as any },
        /* { name: 'User Name', type: 'text', key: 'userName' },
        { name: 'Email', type: 'text', key: 'email' }, */
    ]


    const columnDefs = [
        /* { headerCheckboxSelection: true, checkboxSelection: true, pinned: "left", minWidth: 50, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'User Code', field: 'userCode', headerClass: 'bg-[#f0f0f0]', pinned: "left", minWidth: 120, width: 120, cellRenderer: titleCell }, */
        {
            headerName: 'User Name', field: 'firstName', headerClass: 'bg-[#f0f0f0]', pinned: "left", minWidth: 180, width: 180, valueGetter: (p: any) => {
                const full = [p.data?.firstName, p.data?.lastName].filter(Boolean).join(' ');
                return full || '-';
            }, cellRenderer: titleCell
        },
        { headerName: 'Email', field: 'emailID', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex: 1, cellRenderer: titleCell },
        { headerName: 'Phone No.', field: 'phone', headerClass: 'bg-[#f0f0f0]', minWidth: 90, flex: 1, cellRenderer: titleCell },
        {
            headerName: 'User Type',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 80,
            flex: 1,
            valueGetter: (p: any) =>
                p.data?.userTypes?.map((ut: any) => ut.userTypeName).join(', ') || '-',
            cellRenderer: titleCell
        },
        {
            headerName: 'Facilities',
            field: 'facilities',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 350,
            flex: 1,
            valueGetter: (params: any) =>
                params.data?.facilities?.map((f: any) => f.facilityName).join(', ') || '-',
            cellRenderer: titleCell
        },
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            <option value="delete">Delete</option>
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                setEditData(rowData);
                createUserRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete User',
                    message: 'Are you sure you want to delete this user?',
                    onConfirm: () => {
                        userApi.deleteUser({ RequestID: rowData.userID }, (data: any, msg: any) => {
                            toast.success(msg);
                            getUsers();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;

            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };


    const getUsers = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }


        commonApi.GetUserList(
            payload,
            (resp: any) => {
                setrowData(resp.userList);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                toast.error(error);
            }
        );
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for PDF Export:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            // Mock export functionality - show success message
            toast.success("PDF Export initiated");

            // When API is available, use:
            // const userIDs = selectedData.map((user: any) => user.userID).join(',');
            // const payload = { userIDs: userIDs };
            // userApi.ExportPdf(
            //     payload,
            //     (resp: any) => {
            //         downloadPDF(resp, 'UsersPdf')
            //     },
            //     (error: any) => {
            //         console.log("error =>", error);
            //         toast.error(error);
            //     }
            // );
        }
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            // Mock export functionality - show success message
            toast.success("CSV Export initiated");

            // When API is available, use:
            // const userIDs = selectedData.map((user: any) => user.userID).join(',');
            // const payload = { userIDs: userIDs };
            // userApi.ExportCsv(
            //     payload,
            //     (resp: any) => {
            //         downloadExcel(resp, 'UsersXls')
            //     },
            //     (error: any) => {
            //         console.log("error =>", error);
            //         toast.error(error);
            //     }
            // );
        }
    };

    // Call getUsers only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getUsers();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            getUsers();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: false,
        });
    }, [currentPage, searchParam, filters]);

    return (
        <Layout>
            <Header title='User List'>
                <Header.Right>
                    <Link
                        to={URLS.USERS_SETTING}
                        aria-label="User Settings"
                        title="User Settings"
                        className="pr-4"
                    >
                        <Icon
                            name="settings"
                            size={1.5}
                            className="cursor-pointer text-primary hover:text-primary/80"
                            title="User Settings"
                        />
                    </Link>
                    <Drawer isAfterOpenRender={true} _ref={createUserRef} onClose={() => {
                        setEditData(null);
                    }}>
                        <Drawer.Button>
                            <Button>New User</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit User' : 'New User'} className='!w-[39.5rem]'>
                            {/* Create a CreateUser component and use it here similar to CreateVendor */}
                            <CreateUser UserID={editData?.userID} onCreate={() => {
                                createUserRef.current.close();
                                setEditData(null);
                                getUsers();
                            }} onCancel={() => {
                                setEditData(null);
                                createUserRef.current.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>



                    {/* <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='User Actions'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown> */}
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by User Name or Email' />
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                        Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                    </Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('userFilters');
                        setFiltersApplied({ generalFilter: false, locationFilter: false });
                        setCurrentPage(1);
                    }}>
                        Clear Filters
                    </p>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default User;